export const initContactForm = () => {
    // VARS
    // const form = document.getElementById('contact-form');
    // const nameInput = document.getElementById('form-name');
    // const emailInput = document.getElementById('form-email');
    // const subjectInput = document.getElementById('form-subject');
    // const messageInput = document.getElementById('form-message');
    
    // const errorMessages = {
    //   your_name: "Give us something to call you by",
    //   err_no_name: "Give us something to call you by",
    //   email_label: "Please enter a valid email address",
    //   err_no_email: "Please enter a valid email address",
    //   subject: "Let us know what you're reaching out about",
    //   err_no_subject: "Let us know what you're reaching out about",
    //   err_no_message: "What do you want to talk about?",
    // };
    
    // form.addEventListener('submit', function(event) {
    //   event.preventDefault();
    
    //   let isValid = true;
    
    //   if (nameInput.value.trim() === '') {
    //     showError(nameInput, errorMessages.err_no_name);
    //     isValid = false;
    //   } else {
    //     showValid(nameInput);
    //   }
    
    //   if (emailInput.value.trim() === '') {
    //     showError(emailInput, errorMessages.err_no_email);
    //     isValid = false;
    //   } else if (!isValidEmail(emailInput.value.trim())) {
    //     showError(emailInput, errorMessages.email_label);
    //     isValid = false;
    //   } else {
    //     showValid(emailInput);
    //   }
    
    //   if (subjectInput.value.trim() === '') {
    //     showError(subjectInput, errorMessages.err_no_subject);
    //     isValid = false;
    //   } else {
    //     showValid(subjectInput);
    //   }
    
    //   if (messageInput.value.trim() === '') {
    //     showError(messageInput, errorMessages.err_no_message);
    //     isValid = false;
    //   } else {
    //     showValid(messageInput);
    //   }
    
    //   if (isValid) {
    //     showSuccessMessage();
    //     form.reset();
    //   }
    // });
    
    // function showError(inputElement, errorMessage) {
    //   const parentElement = inputElement.parentElement;
    //   parentElement.classList.remove('valid');
    //   parentElement.classList.add('invalid');
    
    //   let errorElement = parentElement.querySelector('.error-message');
    //   if (!errorElement) {
    //     errorElement = document.createElement('span');
    //     errorElement.classList.add('error-message');
    //     parentElement.appendChild(errorElement);
    //   }
    
    //   errorElement.textContent = errorMessage;
    
    //   const successElement = parentElement.querySelector('.success-message');
    //   if (successElement) {
    //     successElement.remove();
    //   }
    // }
    
    // function showValid(inputElement) {
    //   const parentElement = inputElement.parentElement;
    //   parentElement.classList.remove('invalid');
    //   parentElement.classList.add('valid');
    
    //   const errorElement = parentElement.querySelector('.error-message');
    //   if (errorElement) {
    //     errorElement.remove();
    //   }
    
    //   let successElement = parentElement.querySelector('.success-message');
    //   if (!successElement) {
    //     successElement = document.createElement('span');
    //     successElement.classList.add('success-message');
    //     successElement.textContent = 'Looks good';
    //     parentElement.appendChild(successElement);
    //   }
    // }
    
    // function isValidEmail(email) {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // }
    

    const form = document.getElementById('contact-form');
const nameInput = document.getElementById('form-name');
const emailInput = document.getElementById('form-email');
const subjectInput = document.getElementById('form-subject');
const messageInput = document.getElementById('form-message');

const errorMessages = {
  your_name: "Give us something to call you by",
  err_no_name: "Give us something to call you by",
  email_label: "Please enter a valid email address",
  err_no_email: "Please enter a valid email address",
  subject: "Let us know what you're reaching out about",
  err_no_subject: "Let us know what you're reaching out about",
  err_no_message: "What do you want to talk about?",
};

nameInput.addEventListener('focus', function() {
  removeErrorMessage(nameInput);
});

nameInput.addEventListener('blur', function() {
  if (nameInput.value.trim() === '') {
    showError(nameInput, errorMessages.err_no_name);
  } else {
    showValid(nameInput);
  }
});

emailInput.addEventListener('focus', function() {
  removeErrorMessage(emailInput);
});

emailInput.addEventListener('blur', function() {
  if (emailInput.value.trim() === '') {
    showError(emailInput, errorMessages.err_no_email);
  } else if (!isValidEmail(emailInput.value.trim())) {
    showError(emailInput, errorMessages.email_label);
  } else {
    showValid(emailInput);
  }
});

subjectInput.addEventListener('focus', function() {
  removeErrorMessage(subjectInput);
});

subjectInput.addEventListener('blur', function() {
  if (subjectInput.value.trim() === '') {
    showError(subjectInput, errorMessages.err_no_subject);
  } else {
    showValid(subjectInput);
  }
});

messageInput.addEventListener('focus', function() {
  removeErrorMessage(messageInput);
});

messageInput.addEventListener('blur', function() {
  if (messageInput.value.trim() === '') {
    showError(messageInput, errorMessages.err_no_message);
  } else {
    showValid(messageInput);
  }
});

form.addEventListener('submit', function(event) {
  event.preventDefault();

  let isValid = true;

  if (nameInput.value.trim() === '') {
    showError(nameInput, errorMessages.err_no_name);
    isValid = false;
  }

  if (emailInput.value.trim() === '') {
    showError(emailInput, errorMessages.err_no_email);
    isValid = false;
  } else if (!isValidEmail(emailInput.value.trim())) {
    showError(emailInput, errorMessages.email_label);
    isValid = false;
  }

  if (subjectInput.value.trim() === '') {
    showError(subjectInput, errorMessages.err_no_subject);
    isValid = false;
  }

  if (messageInput.value.trim() === '') {
    showError(messageInput, errorMessages.err_no_message);
    isValid = false;
  }

  if (isValid) {
    showSuccessMessage();
    form.reset();
  }
});

function showError(inputElement, errorMessage) {
  const parentElement = inputElement.parentElement;
  parentElement.classList.remove('valid');
  parentElement.classList.add('invalid');

  let errorElement = parentElement.querySelector('.error-message');
  if (!errorElement) {
    errorElement = document.createElement('span');
    errorElement.classList.add('error-message');
    parentElement.appendChild(errorElement);
  }

  errorElement.textContent = errorMessage;
}

function showValid(inputElement) {
  const parentElement = inputElement.parentElement;
  parentElement.classList.remove('invalid');
  parentElement.classList.add('valid');

  const errorElement = parentElement.querySelector('.error-message');
  if (errorElement) {
    errorElement.remove();
  }

  let successElement = parentElement.querySelector('.success-message');
  if (!successElement) {
    successElement = document.createElement('span');
    successElement.classList.add('success-message');
    successElement.textContent = 'Looks good';
    parentElement.appendChild(successElement);
  }
}

function removeErrorMessage(inputElement) {
  const parentElement = inputElement.parentElement;
  parentElement.classList.remove('invalid');

  const errorElement = parentElement.querySelector('.error-message');
  if (errorElement) {
    errorElement.remove();
  }

  const successElement = parentElement.querySelector('.success-message');
  if (successElement) {
    successElement.remove();
  }
}

function showSuccessMessage() {
  const successElements = document.querySelectorAll('.success-message');
  successElements.forEach(function(successElement) {
    successElement.textContent = 'Looks good';
  });
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

}
